import React from 'react';
import { Col, FormGroup, Row, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { Form, TextBox } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'

class TextBoxDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				preset: "It's a sunny day"
			}
		};
	}

	handleChange = (form) => {
		this.setState({ form });
	}

	handleSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	handleCustomValidationValidate = (value) => {
		if (value === "Hello")
			return "Please do not enter 'Hello' in the textbox.";
	}

	render() {
		const tooltip = (
			<Tooltip id="tooltip">
				<strong>This is a tooltip!</strong><br />Check this info.
			</Tooltip>
		);

		return (
			<Box title="TextBox">
				<Form
					values={this.state.form}
					onChange={this.handleChange}
					onSubmit={this.handleSubmit}>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label>Default</Label>
								<TextBox name="default" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label>Placeholder</Label>
								<TextBox name="placeholder" placeholder="Enter your name" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label>Disabled</Label>
								<TextBox name="disabled" disabled={true} />
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label >Preset</Label>
								<TextBox name="preset" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label required>Required</Label>
								<TextBox name="required" required />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label>Max Length (5)</Label>
								<TextBox name="maxLength" maxLength={5} />
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label>With Tooltip</Label>
								<OverlayTrigger placement="bottom" trigger="focus" overlay={tooltip}>
									<TextBox name="withTooltip" />
								</OverlayTrigger>
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label required>Validation (!= 'Hello')</Label>
								<TextBox name="customValidation" onValidate={this.handleCustomValidationValidate} required />
							</FormGroup>
						</Col>
					</Row>
					<hr />
					<div className="btn-toolbar">
						<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
					</div>
				</Form>
			</Box>
		)
	}
}

export default TextBoxDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/BasicInputs/TextBoxDemo.js